

































































import {
  computed,
  defineComponent,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { computeFieldState } from '~/utils/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import { faUndo } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  props: formFieldProps,
  components: { FieldError },
  setup(props) {
    const { specs, name } = toRefs(props)

    const fromError = ref<any>(null)
    const toError = ref<any>(null)
    const centerError = ref<any>(null)
    const from = ref<any>(undefined)
    const to = ref<any>(undefined)
    const center = ref<any>(undefined)
    const numericRef = ref<HTMLElement | null>(null)

    function onError(error: Ref<any>) {
      if (!error.value) {
        fromError.value = undefined
        toError.value = undefined
        centerError.value = undefined
        return
      }
      if (typeof error.value === 'string') {
        centerError.value = error.value
        return
      }
      if (error.value.from) {
        fromError.value = error.value.from
      }
      if (error.value.to) {
        toError.value = error.value.to
      }
    }

    const isInRangeMode = computed(
      () => specs.value?.value_type === 'range' || false
    )

    const onValue = (value: Ref<any>) => {
      if (value.value === null || value.value === undefined) {
        from.value = undefined
        to.value = undefined
        center.value = undefined
      } else if (isInRangeMode.value) {
        center.value = value.value?.from || value.value?.to || undefined
        to.value = value.value.to
        from.value = value.value.from
      } else if (
        typeof value.value === 'number' ||
        typeof value.value === 'string'
      ) {
        to.value = undefined
        from.value = value.value
        center.value = value.value
      }

      if (process.client) {
        // validate changes
        handleToInput && handleToInput(to.value, false)
        handleFromInput && handleFromInput(from.value, false)
        handleCenterInput && handleCenterInput(center.value, false)
      }
    }

    const {
      debouncedValueChanged,
      suggestions,
      createDatalistElementId
    } = useClassifiedForm(props, { onValue, onError })

    const formValidationBuilder = useDep(FormValidationBuilder)

    const centerIsValid = computed(() => computeFieldState(centerError.value))
    const fromIsValid = computed(() => computeFieldState(fromError.value))
    const toIsValid = computed(() => computeFieldState(toError.value))
    const min = computed(() => specs.value?.min)
    const max = computed(() => specs.value?.max)
    const suffix = computed(() => specs.value?.prefix || specs.value?.suffix)

    const { dispatch } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)

    const undo = () => {
      dispatch('undo')
    }

    const emitValues = () => {
      if (isInRangeMode.value) {
        return debouncedValueChanged(name.value, {
          to: to.value,
          from: from.value
        })
      }
      return debouncedValueChanged(name.value, center.value)
    }

    watch(isInRangeMode, (val, oldVal) => {
      if (oldVal && !val && to.value && process.client) {
        // this means we are changing from range to non-range
        clearRange()
      }
    })

    const clearRange = () => {
      to.value = null
      emitValues()
    }

    const handleCenterInput = (text: string, emit: boolean = true) => {
      const textAsNum = Number(text)
      const validator = formValidationBuilder.new(centerError)
      validator.required(specs.value?.required, textAsNum)
      if (text !== undefined) {
        validator
          .isNumeric(textAsNum)
          .aboveMinNumber(min.value, textAsNum)
          .belowMaxNumber(max.value, textAsNum)
      }
      validator.validate()

      if (emit) {
        emitValues()
      }
    }

    const handleFromInput = (text: string, emit: boolean = true) => {
      const textAsNum = Number(text)
      const validator = formValidationBuilder.new(fromError)
      validator.required(specs.value?.required, textAsNum)
      if (text !== undefined) {
        validator
          .isNumeric(textAsNum)
          .aboveMinNumber(min.value, textAsNum)
          .belowMaxNumber(max.value, textAsNum)
      }
      validator.validate()

      if (emit) {
        emitValues()
      }
    }

    const handleToInput = (text: string, emit: boolean = true) => {
      const textAsNum = Number(text)
      const validator = formValidationBuilder.new(toError)
      validator.required(specs.value?.required, textAsNum)
      if (text !== undefined) {
        validator
          .isNumeric(textAsNum)
          .aboveMinNumber(min.value, textAsNum)
          .belowMaxNumber(max.value, textAsNum)
      }
      validator.validate()

      if (emit) {
        emitValues()
      }
    }

    const suggestionsListId = createDatalistElementId(name)

    return {
      from,
      to,
      center,
      fromError,
      toError,
      centerError,
      isInRangeMode,
      centerIsValid,
      fromIsValid,
      toIsValid,
      min,
      max,
      suffix,
      suggestions,
      suggestionsListId,
      handleCenterInput,
      handleFromInput,
      handleToInput,
      clearRange,
      numericRef,
      undo,
      faUndo
    }
  }
})
